import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    INTEREST_LEVEL_LIST_START: "INTEREST_LEVEL_LIST_START",
    INTEREST_LEVEL_LIST_SUCCESS: "INTEREST_LEVEL_LIST_SUCCESS",
    INTEREST_LEVEL_LIST_FAILED: "INTEREST_LEVEL_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const interestLevelListStart = (data) => ({
    type: actionType.INTEREST_LEVEL_LIST_START,
    payload: data,
});

export const interestLevelListSuccess = (data) => ({
    type: actionType.INTEREST_LEVEL_LIST_SUCCESS,
    payload: data,
});

export const interestLevelListFailed = (data) => ({
    type: actionType.INTEREST_LEVEL_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function interestLevelListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.INTEREST_LEVEL_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.INTEREST_LEVEL_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.INTEREST_LEVEL_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* interestLevelListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allINTEREST_LEVEL =  response.data.data.allInterestlevels.Interestlevels
            yield put(interestLevelListSuccess(allINTEREST_LEVEL));
        } else {
            messagePopup("", "Interest Level List failed", "error");
            yield put(interestLevelListFailed("Interest Level List failed"));
        }
    } catch (error) {
        messagePopup("", "Interest Level List failed", "error");
        yield put(interestLevelListFailed("Interest Level List failed"));
    }
}

export function* watchInterestLevelListSaga() {
    yield takeEvery(actionType.INTEREST_LEVEL_LIST_START, interestLevelListSaga);
}
